
 <!-- <div class="content-wrapper pt-2"> -->
  <!-- Main content -->
  <section class="content">
   
    <!-- Default box -->
    <div class="card card-info" [ngClass]="{'dark-bg' : isDark }">
      <div class="card-header">Solar Power Mgt</div> 
      <form  [formGroup] ="solarPowerForm"  autocomplete="off" (ngSubmit)="saveButtonClick()" class="form-horizontal">
      <fieldset>
      <div class="card-body">

        <div class="row">

        <div class="form-group">
          <input  name="id" readonly formControlName="id"  id="id"  class="form-control"    type="hidden">
          </div>

        <div class="col-md-4">
            <div class="form-group">
            <label for="refCode" class="col-form-label">Ref. Code</label>  
            <div class="input-group">
                <div class="input-group-prepend">
            <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-hashtag"></i></span>
            </div>
            <input   [ngClass]="{'dark-input-field' : isDark }" readonly formControlName="refCode" placeholder="Ref Code"  class="form-control field-bg-color" [class.is-invalid]="formErrors.refCode" (blur)="logValidationErrors()"   type="text">
                </div>
                <span class="text-danger" *ngIf="formErrors.refCode"><small>{{formErrors.refCode}}</small> </span>   
            </div>
          </div>

        <div class="col-md-3">
        <div class="form-group">
            <label for="roomDetails" class="col-form-label ">Room Details</label>  
            <div class="input-group">
              <div class="input-group-prepend">
            <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fas fa-user"></i></span>
            </div>
            <input  [ngClass]="{'dark-input-field' : isDark }" formControlName="roomDetails" placeholder="Room Details"  class="form-control"  type="text">   
              </div>
        </div>
        </div>  


    <div class="col-md-3">
        <div class="form-group">
            <label for="totalGuest" class="col-form-label ">Total Guest</label>  
            <div class="input-group">
              <div class="input-group-prepend">
            <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fas fa-user"></i></span>
            </div>
            <input  [ngClass]="{'dark-input-field' : isDark }" formControlName="totalGuest" placeholder="Total Guest"  class="form-control"  type="text">   
              </div>
        </div>
     </div> 

    </div>

    
    <div class="row">   
        
        <div class="col-md-4">
          <div class="form-group">
            <label for="fromDate" class="col-form-label ">FromDate</label>  
            <div class="input-group">
                <div class="input-group-prepend">
                <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-calendar-o"></i></span>
                </div>
                <input type="text" [ngClass]="{'dark-input-field' : isDark }" bsDatepicker [bsConfig]="datepickerConfig" formControlName="fromDate" class="form-control field-bg-color"  [class.is-invalid]="formErrors.fromDate" (blur)="logValidationErrors()" placeholder="From Date">
            </div>
            <span class="text-danger" *ngIf="formErrors.fromDate"><small>{{formErrors.fromDate}}</small> </span>   
            </div>
         </div>

         <div class="col-md-4">
            <div class="form-group">
            <label for="toDate" class="col-form-label ">ToDate</label>  
            <div class="input-group">
                <div class="input-group-prepend">
                <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-calendar-o"></i></span>
                </div>
                <input type="text" [ngClass]="{'dark-input-field' : isDark }" bsDatepicker [bsConfig]="datepickerConfig" formControlName="toDate" class="form-control field-bg-color"  [class.is-invalid]="formErrors.toDate" (blur)="logValidationErrors()" placeholder="To Date">
            </div>
            <span class="text-danger" *ngIf="formErrors.toDate"><small>{{formErrors.toDate}}</small> </span>   
            </div>
        </div>

    </div>

    <div class="row">  
  
        <div class="col-md-4">
        <div class="form-group">
            <label for="fromTime" class="col-form-label ">From Time</label>  
            <div class="input-group">
                <div class="input-group-prepend">
            <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
            </div>
            <input  name="fromTime" [ngClass]="{'dark-input-field' : isDark }" formControlName="fromTime" placeholder="From Time"  class="form-control" [class.is-invalid]="formErrors.fromTime" (blur)="logValidationErrors()"  type="text">
            </div>
            <span class="text-danger" *ngIf="formErrors.fromTime"><small>{{formErrors.fromTime}}</small> </span>   
        </div>
        </div>
        
        <div class="col-md-4">
            <div class="form-group">
            <label for="toTime" class="col-form-label ">ToTime</label>  
            <div class="input-group">
              <div class="input-group-prepend">
            <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
            </div>
            <input  name="toTime" [ngClass]="{'dark-input-field' : isDark }" formControlName="toTime" placeholder="To Time" class="form-control" [class.is-invalid]="formErrors.toTime" (blur)="logValidationErrors()"  type="text">
          </div>
          <span class="text-danger" *ngIf="formErrors.toTime"><small>{{formErrors.toTime}}</small> </span>   
           </div>
        </div>

    </div>

    <div class="row">  
  
        <div class="col-md-4">        
        <div class="form-group">
            <label for="fromSunbirdMR" class="col-form-label ">FromSunbirdMR</label>  
            <div class="input-group">
              <div class="input-group-prepend">
            <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
            </div>
            <input (keyup)="calculateAmounts()"  [ngClass]="{'dark-input-field' : isDark }" formControlName="fromSunbirdMR" placeholder="FromSunbirdMR"  class="form-control" [class.is-invalid]="formErrors.fromSunbirdMR" (blur)="logValidationErrors()"  type="text">
          </div>
          <span class="text-danger" *ngIf="formErrors.fromSunbirdMR"><small>{{formErrors.fromSunbirdMR}}</small> </span>   
           </div>
        </div>

        <div class="col-md-4">        
            <div class="form-group">
           <label for="toSunbirdMR" class="col-form-label ">ToSunbirdMR</label>  
           <div class="input-group">
             <div class="input-group-prepend">
           <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
           </div>
           <input (keyup)="calculateAmounts()"   [ngClass]="{'dark-input-field' : isDark }" formControlName="toSunbirdMR" placeholder="ToSunbirdMR"  class="form-control" [class.is-invalid]="formErrors.toSunbirdMR" (blur)="logValidationErrors()"  type="text">
         </div>
         <span class="text-danger" *ngIf="formErrors.toSunbirdMR"><small>{{formErrors.toSunbirdMR}}</small> </span>   
          </div>
          </div>

         <div class="col-md-4">        
         <div class="form-group">
          <label for="productionDiff" class="col-form-label ">productionDiff</label>  
           <div class="input-group">
             <div class="input-group-prepend">
           <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
           </div>
           <input readonly  [ngClass]="{'dark-input-field' : isDark }" formControlName="productionDiff" placeholder="Production Diff"  class="form-control field-bg-color" [class.is-invalid]="formErrors.productionDiff" (blur)="logValidationErrors()"  type="text">
         </div>
         <span class="text-danger" *ngIf="formErrors.productionDiff"><small>{{formErrors.productionDiff}}</small> </span>   
          </div>    
        </div>

    </div>



       <div class="row">  
  
        <div class="col-md-4">        
        <div class="form-group">
            <label for="fromEBMRExport" class="col-form-label ">FromEBMRExport</label>  
            <div class="input-group">
              <div class="input-group-prepend">
            <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
            </div>
            <input (keyup)="calculateAmounts()"   [ngClass]="{'dark-input-field' : isDark }" formControlName="fromEBMRExport" placeholder="FromEBMRExport"  class="form-control" [class.is-invalid]="formErrors.fromEBMRExport" (blur)="logValidationErrors()"  type="text">
          </div>
          <span class="text-danger" *ngIf="formErrors.fromEBMRExport"><small>{{formErrors.fromEBMRExport}}</small> </span>   
           </div>
           </div>

        <div class="col-md-4">        
        <div class="form-group">
           <label for="toEBMRExport" class="col-form-label ">ToEBMRExport</label>  
           <div class="input-group">
             <div class="input-group-prepend">
           <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
           </div>
           <input (keyup)="calculateAmounts()"   [ngClass]="{'dark-input-field' : isDark }" formControlName="toEBMRExport" placeholder="ToEBMRExport"  class="form-control" [class.is-invalid]="formErrors.toEBMRExport" (blur)="logValidationErrors()"  type="text">
         </div>
         <span class="text-danger" *ngIf="formErrors.toEBMRExport"><small>{{formErrors.toEBMRExport}}</small> </span>   
          </div>
        </div>

        <div class="col-md-4">        
        <div class="form-group">
          <label for="exportDiff" class="col-form-label ">Export Diff</label>  
           <div class="input-group">
             <div class="input-group-prepend">
           <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
           </div>
           <input  readonly [ngClass]="{'dark-input-field' : isDark }" formControlName="exportDiff" placeholder="Export Diff"  class="form-control field-bg-color" [class.is-invalid]="formErrors.exportDiff" (blur)="logValidationErrors()"  type="text">
         </div>
         <span class="text-danger" *ngIf="formErrors.exportDiff"><small>{{formErrors.exportDiff}}</small> </span>   
          </div>       
        </div>

        </div>

         <div class="row">  
  
        <div class="col-md-4">        
        <div class="form-group">
            <label for="fromEBMRConsume" class="col-form-label ">FromEBMRConsume</label>  
            <div class="input-group">
              <div class="input-group-prepend">
            <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
            </div>
            <input  (keyup)="calculateAmounts()"  [ngClass]="{'dark-input-field' : isDark }" formControlName="fromEBMRConsume" placeholder="FromEBMRConsume"  class="form-control" [class.is-invalid]="formErrors.fromEBMRConsume" (blur)="logValidationErrors()"  type="text">
          </div>
          <span class="text-danger" *ngIf="formErrors.fromEBMRConsume"><small>{{formErrors.fromEBMRConsume}}</small> </span>   
           </div>
        </div>

        <div class="col-md-4">        
            <div class="form-group">
           <label for="toEBMRConsume" class="col-form-label ">ToEBMRConsume</label>  
           <div class="input-group">
             <div class="input-group-prepend">
           <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
           </div>
           <input (keyup)="calculateAmounts()"   [ngClass]="{'dark-input-field' : isDark }" formControlName="toEBMRConsume" placeholder="ToEBMRConsume"  class="form-control" [class.is-invalid]="formErrors.toEBMRConsume" (blur)="logValidationErrors()"  type="text">
         </div>
         <span class="text-danger" *ngIf="formErrors.toEBMRConsume"><small>{{formErrors.toEBMRConsume}}</small> </span>   
          </div>
        </div>


        <div class="col-md-4">        
            <div class="form-group">
          <label for="consumeDiff" class="col-form-label ">Consume Diff</label>  
           <div class="input-group">
             <div class="input-group-prepend">
           <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
           </div>
           <input readonly  [ngClass]="{'dark-input-field' : isDark }" formControlName="consumeDiff" placeholder="Consume Diff"  class="form-control field-bg-color" [class.is-invalid]="formErrors.consumeDiff" (blur)="logValidationErrors()"  type="text">
         </div>
         <span class="text-danger" *ngIf="formErrors.consumeDiff"><small>{{formErrors.consumeDiff}}</small> </span>   
          </div>
        </div>
            
        </div>

        <div class="row">  
            <div class="col-md-4">        
            <div class="form-group">
            <label for="netExportOrConsume" class="col-form-label ">NetExportOrConsume</label>  
            <div class="input-group">
              <div class="input-group-prepend">
            <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
            </div>
            <input readonly  [ngClass]="{'dark-input-field' : isDark }" formControlName="netExportOrConsume" placeholder="Net Export/Consume"  class="form-control field-bg-color" [class.is-invalid]="formErrors.netExportOrConsume" (blur)="logValidationErrors()"  type="text">
          </div>
          <span class="text-danger" *ngIf="formErrors.netExportOrConsume"><small>{{formErrors.netExportOrConsume}}</small> </span>   
           </div>      
        </div>
     </div>


      </div>                                
      <!-- /.card-body -->
      <div class="card-footer">
        <button type="button" (click)="newButtonClick()" class="btn btn-success ml-2">New</button>

        <button *ngIf="crud_access.create"  type="submit" [disabled]="isSaveBtnDisabled" class="btn btn-primary ml-2">
          <span *ngIf ="showProcessingIndicator" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Save
        </button>

        <button class="btn btn-primary ml-2" routerLink="../solar-power-list"><i class="fa fa-table p-1"></i>Solar Power List</button>
        <button  type="button"  *ngIf ="isShowAttachBtn" class="btn btn-primary ml-2" (click)="attachFileButtonClick()"><i class="fa fa-plus p-1"></i>Attach Files</button>        
      </div>
      <!-- /.card-footer-->
    </fieldset>
      </form>
    </div>
  </section>
    <!-- </div> -->


    <!-- Form Values : {{ addCustomerForm.value | json }} -->
  
